import { render, staticRenderFns } from "./ManageNotificationPreferences.vue?vue&type=template&id=bb4124f0&"
import script from "./ManageNotificationPreferences.vue?vue&type=script&lang=js&"
export * from "./ManageNotificationPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports